import { useEffect } from 'react'

import { toggleArray } from '@domain-group/javascript-utils'
import { useSetState } from '@domain-group/react-hooks'

import useAgencyTags from '@hooks/useAgencyTags'

const defaultState = {
  editing: false,
  selectedTags: [],
}

type UseTagSelectorOptions = {
  callbacks: {
    updateTags: (tags: string[]) => void,
  },
  filters: {
    agency_id: number,
  },
  selectedTags: string[],
}

function useTagSelector(options: UseTagSelectorOptions) {
  const {
    callbacks: {
      updateTags,
    },
    filters,
    selectedTags: initSelectedTags,
  } = options

  const [state, setState] = useSetState(defaultState)
  const { editing, selectedTags } = state

  useEffect(() => {
    if (!selectedTags.length && initSelectedTags.length){
      setState({
        editing: true,
        // @ts-expect-error TS2322
        selectedTags: initSelectedTags,
      })
    }
  }, [initSelectedTags.length])

  const agencyTagsPayload = useAgencyTags({
    filters,
    performHttpRequests: editing,
  })

  const { filteredAgencyTags, hasFilteredAgencyTags, loading } = agencyTagsPayload

  return {
    callbacks: {
      setState,
      toggleTag: (tag: string) => {
        const updatedTags = toggleArray(selectedTags, tag)

        updateTags(updatedTags)

        setState({
          // @ts-expect-error
          selectedTags: updatedTags,
        })
      },
    },
    editing,
    filteredAgencyTags,
    hasFilteredAgencyTags,
    loading,
    selectedTags,
  }
}

export default useTagSelector
